import { render, staticRenderFns } from "./postage.vue?vue&type=template&id=d557a37a&scoped=true&"
import script from "./postage.vue?vue&type=script&lang=js&"
export * from "./postage.vue?vue&type=script&lang=js&"
import style0 from "./postage.vue?vue&type=style&index=0&id=d557a37a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d557a37a",
  null
  
)

export default component.exports